<h2 mat-dialog-title style="text-align:center; margin-bottom: 16px;">Create Asset</h2>
<mat-dialog-content>
  <div style="display: flex; gap: 20px;">
    <mat-form-field class="form-field form-field-half" color="accent">
      <mat-label>Id</mat-label>
      <mat-icon matPrefix>fingerprint</mat-icon>
      <input [(ngModel)]="id" matInput>
    </mat-form-field>
    <mat-form-field class="form-field form-field-half" color="accent">
      <mat-label>Name</mat-label>
      <mat-icon matPrefix>label</mat-icon>
      <input [(ngModel)]="name" matInput>
    </mat-form-field>
  </div>
  <div style="display: flex; gap: 20px;">
    <mat-form-field class="form-field form-field-half" color="accent">
      <mat-label>Content Type</mat-label>
      <mat-icon matPrefix>description</mat-icon>
      <input [(ngModel)]="contenttype" matInput [placeholder]="'text/plain'">
    </mat-form-field>

    <mat-form-field class="form-field form-field-half" color="accent">
      <mat-label>Version</mat-label>
      <mat-icon matPrefix>history</mat-icon>
      <input [(ngModel)]="version" matInput [placeholder]="'1.0'">
    </mat-form-field>
  </div>


    <mat-form-field class="form-field-stretch" color="accent" id="form-field-destination">
      <mat-label>Destination</mat-label>
      <mat-icon matPrefix>cloud_upload</mat-icon>
      <mat-select [(ngModel)]="storageTypeId">
        <mat-option *ngFor="let storageType of storageTypes " [value]="storageType.id">
          {{storageType.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="storageTypeId === 'AmazonS3' || storageTypeId === 'AzureStorage'">
      <mat-form-field class="form-field-stretch" color="accent" id="form-field-account">
        <mat-label>Account</mat-label>
        <mat-icon matPrefix>account_circle</mat-icon>
        <input [(ngModel)]="account" matInput>
      </mat-form-field>

      <mat-form-field class="form-field" color="accent" id="form-field-container">
        <mat-label>Container</mat-label>
        <mat-icon matPrefix>inbox</mat-icon>
        <input disabled [(ngModel)]="container" matInput>
      </mat-form-field>

      <mat-form-field class="form-field" color="accent" id="form-field-blobname">
        <mat-label>Blob Name</mat-label>
        <mat-icon matPrefix>insert_drive_file</mat-icon>
        <input [(ngModel)]="blobname" matInput>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="storageTypeId === 'HttpProxy'">
      <mat-form-field class="form-field-stretch" color="accent" id="form-field-http-proxy">
        <mat-label>Url</mat-label>
        <mat-icon matPrefix>link</mat-icon>
        <input [(ngModel)]="baseUrl" matInput>
      </mat-form-field>
    </ng-container>

</mat-dialog-content>



<mat-dialog-actions>
    <button color="warn" mat-dialog-close mat-stroked-button>
        <mat-icon>cancel</mat-icon> Cancel
    </button>
    <button (click)="onSave()" color="accent" mat-flat-button>
        <mat-icon>add_circle</mat-icon> Create
    </button>
</mat-dialog-actions>
